import { JSONValue, JSONObject, Message } from "@twilio/conversations";
import { Customer } from "../services/conversations/definitions/types";
import { LiveChatAttributes } from "../hooks/useLiveChat/definitions";

export const getMessageDirection = (customer: Customer, message: Message) => {
  if (!customer.sid) {
    return customer.identity === message.author ? "outbound" : "inbound";
  }

  return customer.sid === message.participantSid ? "outbound" : "inbound";
};

/**
 * Type guard to check if a attribute(JSONValue) is a JSONObject.
 *  - The usage is strictly for handling attributes in Conversations SDK for objects like
 *    Message, Conversations, Participant, etc.,
 */
export const isJsonObject = (
  attributes: JSONValue
): attributes is JSONObject => {
  return (
    attributes !== null &&
    typeof attributes === "object" &&
    !Array.isArray(attributes)
  );
};

export const isEmptyObject = (obj: object): boolean => {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
};

export const getAttribute = ({
  attributes,
  key,
  fallbackValue = null,
}: {
  attributes: LiveChatAttributes | JSONValue;
  key: string;
  fallbackValue?: any;
}) => {
  if (!attributes || !isJsonObject(attributes) || isEmptyObject(attributes)) {
    return fallbackValue;
  }

  return attributes[key] || fallbackValue;
};
